import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { SquareComponent } from "./square.component";

@NgModule({
  declarations: [SquareComponent],
  imports: [CommonModule, MatTooltipModule, TranslateModule],
  exports: [SquareComponent]
})
export class SquareModule {}
